<template>
  <div>
    <!-- Customer history overlay -->
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
      :baseZIndex=-10
      :dismissable="false"
    >
      <!-- <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      /> -->

      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer1"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />

      <DataTable 
        :value="customerHistory"
        :paginator="true"
        dataKey="id"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
        :rows="10"
        :rowHover="true"
        :loading="loading"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        currentPageReportTemplate="{first} to {last} of {totalRecords} Customer Histories"
      >
        <Column field="dateCreated" header="Date"></Column>
        <Column
          field="user"
          header="User"
          headerStyle="width: 10em"
          :sortable="true"
        >
          <template #body="slotProps">
            <div>
              {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
            </div>
          </template>
        </Column>
        <Column field="histType" header="Type"></Column>
        <Column field="histDesc" header="Description">
          <template #body="slotProps">
            <div class="under_lined" @click="goTo(slotProps.data)">
              {{ slotProps.data.histDesc }}
            </div>
          </template>
        </Column>
        <Column field="eventStatus" header="Status"></Column>
      </DataTable>
    </OverlayPanel>

    <!-- Action buttons overlay -->
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 380px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="p-field p-col"
            v-for="(obj, index) in actionButtons1" 
            :key="index"
            style="margin: 0px; text-align: center; padding: 0px;"
          >
            <Button 
              :label="obj.label" 
              :icon="obj.icon"
              :disabled="obj.disabled ? obj.disabled : false"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
        <hr />
        <div class="row" style="background-color: white;">
          <div class="col col-lg-6 col-md-6">
            <Button 
              v-for="(obj, index) in actionButtons2" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
              style="text-align: left;"
            />
          </div>
          <div class="col col-lg-6 col-md-6">
            <Button 
              v-for="(obj, index) in actionButtons3" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
              :disabled="obj.disabled ? obj.disabled : false"
            />
          </div>
        </div>
        <hr v-if="$store.getters['auth/getMyProfile'] && $store.getters['auth/getMyProfile'].role && $store.getters['auth/getMyProfile'].role.roleName && $store.getters['auth/getMyProfile'].role.roleName === 'Admin'"/>
        <div 
          class="row" 
          style="background-color: white;"
          v-if="$store.getters['auth/getMyProfile'] && $store.getters['auth/getMyProfile'].role && $store.getters['auth/getMyProfile'].role.roleName && $store.getters['auth/getMyProfile'].role.roleName === 'Admin'"
        >
          <div class="p-field p-col" style="text-align: center; margin: 0px; padding: 0px;" v-if="assignToCustomer">
            <Button 
              :label="assignToCustomerAction.label" 
              :icon="assignToCustomerAction.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(assignToCustomerAction)"
            />
          </div>
          <div class="p-field p-col" style="text-align: center; margin: 0px; padding: 0px;" v-else-if="selectedRow && !selectedRow.requireApproval && haveMergeIntoPermission">
            <Button 
              label="Merge Into" 
              class="p-button-text p-button-plain" 
              @click="mergeCustomer()"
            />
          </div>
        </div> 
      </div>
    </OverlayPanel>

    <!-- Customers data table -->
    <DataTable
      :key="tableKey" 
      :value="data"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      dataKey="customerId"
      :rowHover="true"
      :selection.sync="selectedCustomers"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Customers"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="tableSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight="1100px"
      frozenWidth="50px"
    >
      <template #empty> No customers found. </template>
      <template #loading> Loading customers data. Please wait. </template>
      <div
        :key="columnsKey"
      >
        <!-- <Column 
          selectionMode="multiple" 
          headerStyle="width: 3em;"
        ></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
            >
              <Button 
                icon="pi pi-ellipsis-h" 
                class="p-button-rounded p-button-text"
                @click="toggleActions($event, slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <Column 
          v-for="(col, index) of colSelectedFieldsForTable" 
          :key="col.dbField + '_' + index"
          :field="getOptionLabel(col)[0]" 
          :sortField="sortKeyOf(col, colSelectedFieldsForTable)"
          :header="col.fieldName" 
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'" 
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px;"
              @click="openOP(slotProps.data, col, $event)"
              :class="getStyle2(col)"
            >
              {{ getToShow(slotProps.data, col) }}
            </div>
          </template>
        </Column>
        <!-- <Column 
          header="Actions"
          headerStyle="width: 9em;"
        >
          <template #body="slotProps">
            <div
              class="splitButtonColumn"
              :style="{position: 'absolute'}"
            >
              <SplitButton 
                label="View" 
                icon="pi pi-info" 
                @click="viewCustomer(slotProps.data)" 
                :model="getButtons(slotProps.data)"
              >
              </SplitButton>
            </div>
          </template>
        </Column> -->
      </div>
    </DataTable>

    <div class="flex justify_space_between my-1">
      <div>
      </div>
      <div 
        style="width: 250px; display: flex; justify-content: flex-end;" 
      >
        <ProgressSpinner
          v-if="makingExport"
          style="width:100%; height:25px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Export Customers to Excel"
          icon="pi pi-external-link"
          style="width: 210px;"
          @click="$emit('exportData')"
        />
      </div>
    </div>

    <ContextMenu :model="getButtons(selectedRow)" ref="cm" />

    <Dialog header="Confirm" :visible.sync="deleteConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>Do you want to delete this customer: {{ tempObj.custName }}</span>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" @click="deleteConfirmation = false" class="p-button-text" autofocus />
        <Button label="Ok" icon="pi pi-check" @click="deleteCustomer()" class="p-button-text" autofocus />
      </template>
    </Dialog>
          
    <!-- Activity form --> 
    <component
      :key="activityFormKey"
      :is="activityForm"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="disabledArr"
      @close="activityDialog = false"
      @saved="activityDialog = false"
    />

    <!-- Note form -->
    <component
      :is="noteForm"
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="disabledArr"
      @close="noteDialog = false"
      @noteSaved="noteSaved()"
    />
    
    <!-- Enquiry form -->
      <!-- :key="enquiryFormKey" -->
    <component
      :is="enquiryForm"
      v-if="enquiryDialog"
      :opportunityDialog="enquiryDialog"
      :opportunityToEdit='enquiry'
      :disabledArray="disabledArr"
      @close="enquiryDialog = false"
    />
    
    <!-- Contact form -->
    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactDialog"
      :disabledArr="disabledArr"
      @hide-form-dialog="contactDialog = false"
      @submit-contact-form="savedContact"
    />

    <!-- Contact duplicate form -->
    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      @hide-duplicate-dialog="duplicateDialog = false"
      @submit-duplicate-form="saveDuplicate"
    />
    
    <!-- Enquiry form -->
    <OpportunityForm
      :key="enquiryFormKey"
      v-if="openOpportunityDialog"
      :opportunityDialog="openOpportunityDialog"
      :opportunityToEdit="opportunityToEdit"
      :disabledArray="disabledArr"
      :colSelectedFieldsForTable="colSelectedFieldsForTableEnquiry"
      @close="openOpportunityDialog = false"
      @save="savedOpportunity"
    />

    <!-- Enquiry duplicate dialog -->
    <duplicateTable
      v-if="colSelectedFieldsForTable"
      :duplicateDialog="displayDuplicateMessage"
      :colSelectedFieldsForTable="colSelectedFieldsForTableEnquiry"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="duplicates"
      :requesting="duplicateRequesting"
      @close="displayDuplicateMessage = false"
      @agree="sendDuplicate"
    />
    
    <!-- Enquiry scuccess dialog -->
    <Dialog header="Success" :visible.sync="displaySuccess" :style="{width: '500px'}" :modal="true">
        <div class="confirmation-content">
            <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
            <span>A new enquiry was saved successfully. The sQuote No is {{ savedSQuoteNo }}</span>
        </div>
        <template #footer>
          <Button label="Ok" icon="pi pi-check" @click="displaySuccess = false" class="p-button-text" autofocus />
          <Button 
            @click="displaySuccess = false; newQuote()"
            label="Book In"
          />
        </template>
    </Dialog>

    <!-- Quotation form -->
    <QuotationForm
      :quotationDialog="quotationDialog"
      :opportunity="realOpportunity"
      :active="activeQuote"
      :quoteToEdit="quotation"
      :disabledArr="disabledArr"
      @close="quotationDialog = false"
      @saved="saved"
    />

    <!-- Attachment form -->
    <AttachmentForm
      :key="attachmentKey"
      :quotation="quotation"
      :attachmentForm="attachmentForm"
      :customer="tempCustomer"
      :attachment="{}"
      @close="attachmentForm = false"
      @saved="savedAttachment"
    />

    <MergeDialog
      v-if="selectedRow && selectedRow.customerId"
      :mergeDialog="mergeDialog"
      :reloadDialog="reloadMergeDialog"
      :customerNames="customerNames"
      :customer="selectedRow"
      @close="mergeDialog = false"
      @success="mergeDialog = false, reload()"
    />

    <LinkedAccountsDialog
      v-if="selectedRow && selectedRow.customerId"
      :showDialog="linkedAccountsTableDialog"
      :reloadDialog="reloadLinkedAccountsTableDialog"
      :customer="selectedRow"
      @close="linkedAccountsTableDialog = false"
    />

    <Chart style="visibility: hidden;" v-if="chartHide"
      ref="myChart"
      type="bar" 
      :data="chartData" 
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { columnSortKey, sortChangeFor, restoreSortKey } from '@/mbp/universalComponents/listSort'
import { formatCurrency } from '@/utils/money'

import moment from "moment"
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

import CustomerService from "@/service/CustomerService"
import FiltersService from "@/service/FiltersSerice"
import ActivityService from "@/service/ActivityService";
import OpportunityService from "@/service/OpportunityService";
import UserService from "@/service/UserService"

import HistoryTable from './customerHistoryTable'
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import NoteForm from '@/mbp/universalComponents/note/NoteForm'
import ContactForm from '@/mbp/universalComponents/contact/contactForm'
import DuplicateDialog from '@/mbp/universalComponents/contact/duplicateDialog'
import OpportunityForm from "@/mbp/universalComponents/opportunity/OpportunityForm.vue";
import duplicateTable from '@/mbp/universalComponents/opportunity/duplicateDialog'
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import AttachmentForm from '@/mbp/universalComponents/attachment/attachmentForm'
import MergeDialog from './MergeDialog'
import LinkedAccountsDialog from './LinkedAccountsDialog'

import {
  columnSelectionRequest
} from '../sendRequest'
import { keepOverlayOnScreen, topbarBottom } from '@/utils/keepOverlayOnScreen'

export default {
  components: {
    HistoryTable,
    ActivityForm,
    NoteForm,
    ContactForm,
    DuplicateDialog,
    OpportunityForm,
    duplicateTable,
    QuotationForm,
    AttachmentForm,
    MergeDialog,
    LinkedAccountsDialog
  },
  created() {
    this.toggleActionFirst = true
    let permission = this.myPermissions.find(a => a.permission.permissionCode === 'Action-ViewMBPBranchAccounts');
    if (permission) {
      if (permission.permissionLevel !== 0) {
        this.actionButtons2.push({
          label: 'View MBP Branch Accounts',
          icon: 'pi pi-inbox',
          command: (that) => {
            that.viewCustomerLinkedAccounts(that.selectedRow)
          }
        })
      } 
    } 
    let per = this.myPermissions.find(a => a.permission.permissionCode === 'Report-SingleCustomer');
    if (per) {
      if (per.permissionLevel !== 0) {
        this.actionButtons3.push({
        label: 'Download Customer Info',
        icon: 'pi pi-file',
        command: (that) => {
          that.downloadCustomerInfo(that.selectedRow)
        }
      })
      } 
      if(per.permissionLevel === 5) {
        this.onlyUserBranchCustomerInfoReport = true
      } else {
        this.onlyUserBranchCustomerInfoReport = false
      }
    } 
    this.setupComponent()
    if (this.$route.name === 'custApprovals') {
      this.actionButtons3.splice(1, 1) // Removing "New Activity" option if the customer is not approved
    }
  },
  mounted() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
    
    this.getColumnSelectionEnquiry()
    this.getDBViewFieldsEnquiry()
    this.setupActionButtons1();
  },
  updated() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  props: [
    'dbView',
    'data',
    'loading',
    'dbViewFields',
    'colSelectedFields',
    'colSelectedFieldsForTable',
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'assignToCustomer',
    'customerNames',
    'makingExport'
  ],
  data: () => ({
    customerService: new CustomerService(),
    filtersService: new FiltersService(),
    activityService: new ActivityService(),
    opportunityService: new OpportunityService(),
    userService: new UserService(), // For Chart
    selectedCustomers: null,
    selectedRow: null,
    selected: [], // columns selected
    customerHistory: [],
    customerHistoryLoading: false,
    tempObj: {},
    deleteConfirmation: false,
    
    previousPage: null,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortFieldId: null,
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    sendingRequest: false,

    // history component
    activityDialog: false,
    disabledArr: [],
    activity: {},
    activityFormKey1: 0,
    noteDialog: false,
    note: {},
    reloadNoteForm: 0, // this is not the key
    unRequestedActivity: true,
    unRequestedNote: true,
    enquiry: {},
    enquiryFormKey1: 0,
    enquiryDialog: false,
    unRequestedEnquiry: true,

    onlyUserBranchCustomerInfoReport: false,
    toggleActionFirst: false,
    entryIndex: 0,

    actionButtons1: [],
    actionButtons2: [
      {
        label: 'View Contacts',
        icon: 'pi pi-id-card',
        command: (that) => {
          that.viewCustomerContacts(that.selectedRow)
        }
      },
      {
        label: 'View Tasks & Events',
        icon: 'pi pi-calendar',
        command: (that) => {
          that.viewCustomerActivities(that.selectedRow)
        }
      },
      {
        label: 'View Quotations',
        icon: 'pi pi-money-bill',
        command: (that) => {
          that.viewCustomerQuotations(that.selectedRow)
        }
      },
      {
        label: 'View Notes',
        icon: 'pi pi-align-justify',
        command: (that) => {
          that.viewCustomerNotes(that.selectedRow)
        }
      },
      {
        label: 'View Attachments',
        icon: 'pi pi-file',
        command: (that) => {
          that.viewCustomerAttachments(that.selectedRow)
        }
      },
      {
        label: 'View Sales Stats',
        icon: 'pi pi-chart-line',
        command: (that) => {
          that.viewCustomerSalesStats(that.selectedRow)
        }
      },
      {
        label: 'View History',
        icon: 'pi pi-inbox',
        command: (that) => {
          that.viewCustomerHistory(that.selectedRow)
        }
      }
    ],
    actionButtons3: [
      { 
        label: 'New Contact',
        icon: 'pi pi-id-card',
        command: (that) => {
          that.newContact(that.selectedRow)
        }
      },
      {
        label: 'New Task or Event',
        icon: 'pi pi-calendar',
        command: (that) => {
          that.newActivity(that.selectedRow)
        }
      },
      {
        label: 'New Enquiry',
        icon: 'pi pi-money-bill',
        command: (that) => {
          that.newEnquiry(that.selectedRow)
        }
      },
      {
        label: 'New Note',
        icon: 'pi pi-align-justify',
        command: (that) => {
          that.newNote(that.selectedRow)
        }
      },
      {
        label: 'New Attachment',
        icon: 'pi pi-file',
        command: (that) => {
          that.newAttachment(that.selectedRow)
        }
      },
      // {
      //   label: 'Download Customer Info',
      //   icon: 'pi pi-file',
      //   command: (that) => {
      //     that.downloadCustomerInfo(that.selectedRow)
      //   }
      // }
    ],
    assignToCustomerAction: {
      label: 'Assign To Customer',
      icon: 'pi pi-id-card',
      command: (that) => {
        if (that.selectedRow && that.selectedRow.customerId) {
          that.$emit('customerForApproval', that.selectedRow)
        }
      }
    },
    tempCustomer: {},
    contactToEdit: {},
    contactDialog: false,
    reloadContactForm: 0,
    duplicateToSend: {},
    duplicateContact: {},
    duplicateDialog: false,
    duplicateDialogKey1: 0,
    openOpportunityDialog: false,
    opportunityToEdit: {},
    duplicates: [],
    enquiryFormKey1: 0,
    selectedCustomer: {},
    realOpportunity: {},
    displayDuplicateMessage: false,
    dbViewEnquiry: 3, // for enquiries
    dbViewFieldsEnquiry: [],
    colSelectedFieldsEnquiry: [],
    colSelectedFieldsForTableEnquiry: [],
    savedSQuoteNo: '',
    displaySuccess: false,
    duplicateRequesting: false,
    quotationDialog: false,
    quotation: {},
    activeQuote: false,
    attachment: {},
    attachmentForm: false,
    attachmentKey1: 0,
    mergeDialog: false,
    reloadMergeDialog: 0,
    linkedAccountsTableDialog: false,
    reloadLinkedAccountsTableDialog: 0,

    // chart thing
    chartHide: false,
    chartData: {},
    chartOptions: {
      responsive: true,
      title: {
        display: true,
        text: 'Sales Analysis'
      },
      tooltips: {
        mode: 'index',
        intersect: true,
        callbacks: {
                    label: function(context, dataset) {
                      var l = dataset.datasets[context.datasetIndex].label
                      var b = context.yLabel
                      b = b.toLocaleString('en-GB', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                      return l + ': ' + '£'+b;
                    }
                  }
      },
      scales: {
              yAxes: [
                  {
                      ticks: {
                          callback: function(label, index, labels) {
                              return '£'+label.toLocaleString();
                          }
                      }
                  }
        ]
      },
    },
  }),
  computed: {
    /** C2: the saved sort, shown on the right column when columns share a db_field last segment. */
    tableSortField() {
      return restoreSortKey(this.defaultSortField, this.defaultSortFieldId, this.colSelectedFieldsForTable)
    },
    myPermissions() {
        return this.$store.getters['auth/getUserPermissions']
    },
    haveMergeIntoPermission() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'Action-MergeCustomers');
      if (permission) {
        if (permission.permissionLevel === 0) {
          return false
        } 
      }
      return true
    },
    splitButtonLocationReset() {
      return this.$store.getters.getSplitButtonLocationReset
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    },
    activityFormKey: {
      set() {
        this.activityFormKey1++
      },
      get() {
        return 'activityFormKey-' + this.activityFormKey1.toString()
      }
    },
    enquiryFormKey: {
      set(val) {
        
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey' + this.enquiryFormKey1.toString()
      }
    },
    activityForm() {
      return (this.unRequestedActivity === false || this.activityDialog) ? ActivityForm : null
    },
    noteForm() {
      return (this.unRequestedNote === false || this.noteDialog) ? NoteForm : null
    },
    enquiryForm() {
      return (this.unRequestedEnquiry === false || this.enquiryDialog) ? OpportunityForm : null
    },
    duplicateDialogKey: {
      set() {
        this.duplicateDialogKey1++
      },
      get() {
        return 'duplicateDialogKey-' + this.duplicateDialogKey1.toString()
      }
    },
    enquiryFormKey: {
      set(val) {
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey-' + this.enquiryFormKey1.toString()
      }
    },
    attachmentKey: {
      set(val) {
        this.attachmentKey1++
      },
      get() {
        return 'attachmentForm' + this.attachmentKey1.toString()
      }
    }
  },
  watch: {
    splitButtonLocationReset(val) {
      this.setSplitButtonLocations()
    },
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    data(val) {
      this.columnsKey++
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        this.setSplitButtonLocations()
        columnSelectionRequest(this, 'CustomersDataTableForLazyWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {
      
      this.columnsKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    },
    contactDialog(val) {
      this.reloadContactForm++
    },
    duplicateDialog(val) {
      this.duplicateDialogKey++
    },
    openOpportunityDialog(val) {
      if (val) {
        this.enquiryFormKey++
      }
    },
    dbViewFieldsEnquiry(val) {

      // 
      if (this.colSelectedFieldsForTableEnquiry.length < 1) {
        this.colSelectedFieldsForTableEnquiry = val.filter(a => a.defView)
      }
      // this.colSelectedFieldsForTableEnquiry.forEach(a => 
    },
    quotationDialog(val) {
      // 
      if (val && this.realOpportunity && this.realOpportunity.customer && this.realOpportunity.customer.requireApproval === true) {
        this.quotationDialog = false

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000,
        })
      }
    },
    attachmentForm(val) {
      this.attachmentKey++
    }
  },
  methods: {
    setupActionButtons1() {
      this.actionButtons1 = [
        {
          label: 'View',
          icon: 'pi pi-info',
          command: (that) => {
            that.viewCustomer(that.selectedRow)
          }
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          disabled: false,
          command: (that) => {
            that.editCustomer(that.selectedRow)
          }
        }
      ]


      this.actionButtons1.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: (that) => {
            that.tempObj = that.selectedRow
            that.deleteConfirmation = true
          }
      })
    
    },
    savedAttachment({ file, attachment }) {
      this.attachmentForm = false
      this.attachment = {}
    },
    newAttachment(customer) {
      if (customer && customer.customerId) {
        this.tempCustomer = customer
        
        this.quotation = {}
        this.attachmentForm = true
      }
    },
    noBranchHandle() {
      this.$router.push({ name: 'dashboard' , query: { toast: 'yes' }})
    },
    getDates() {
      // Create a new date object for today
      const today = new Date()

      // Subtract 6 months from today's date
      const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate())

      // Format the date as a string in "YYYY/MM/DD" format
      const sixMonthdateString = sixMonthsAgo.getFullYear() + "/" + (sixMonthsAgo.getMonth() + 1).toString().padStart(2, '0') + "/" + sixMonthsAgo.getDate().toString().padStart(2, '0')

      const todayDateString = today.getFullYear() + "/" + (today.getMonth() + 1).toString().padStart(2, '0') + "/" + today.getDate().toString().padStart(2, '0')

      // return the result
      return [sixMonthdateString, todayDateString]
    },
    async downloadCustomerInfo(customer) {
      this.chartHide = true
      let logoDataUri = "data:image/png;base64,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";

      this.$store.dispatch('setUploading', true)
      this.$store.dispatch('setPercentageUploaded', Math.round(0))
      this.$store.dispatch('setProgressMsg', 'Report downloading: ')

      try 
      {
        let path = `/v1/getCustomerGraphData/${customer.customerId}`

        this.userService
          .getCustomUserWidgetData(path)
          .then(async data => {
            this.loadingData = false
            this.$store.dispatch('setPercentageUploaded', Math.round(10))

            if (data && data.datasets && data.labels) {
              let a = {...data}
              
              a.datasets[0].data = a.datasets[0].dataVal
              a.datasets[1].data = a.datasets[1].dataVal
              a.datasets[2].data = a.datasets[2].dataVal

              this.chartData = a

              try {
                var branch = this.$store.getters['auth/getMyProfile'].defBranch

                if(!branch)
                {
                  this.noBranchHandle()
                  return
                }
                var yaxis = 20
                var doc = new jsPDF('landscape')
                var pageWidth = doc.internal.pageSize.getWidth()

                doc.setFillColor(236, 240, 241)
                doc.rect(0, yaxis, pageWidth, 50, 'F')

                doc.setFillColor(9, 132, 227)
                doc.rect(0, yaxis, 3, 50, 'F')

                yaxis += 10
                doc.addImage(logoDataUri, 'PNG', pageWidth-90, yaxis, 416 * 0.20, 100 * 0.30)

                doc.setTextColor(9, 132, 227)
                doc.setFontSize(22)

                doc.setFont('helvetica', 'bold')
                doc.text(20, yaxis, 'Customer Report')

                doc.setFontSize(12)
                doc.setFont('helvetica', 'normal')

                var date = moment().format('LLLL')
                var custName = customer.custName
                var accountNo = customer.custCode

                yaxis += 12
                doc.setTextColor(149, 165, 166)
                doc.text(20, yaxis, "Customer Name")
                doc.setTextColor(9, 132, 227)
                if(!custName) custName = '-'
                doc.text(75, yaxis, custName)

                yaxis += 8
                doc.setTextColor(149, 165, 166)
                doc.text(20, yaxis, "Account Number")
                doc.setTextColor(9, 132, 227)

                if(!accountNo) accountNo = '-'
                doc.text(75, yaxis, accountNo)

                yaxis += 8
                doc.setTextColor(149, 165, 166)
                doc.text(20, yaxis, "Date & Time")
                doc.setTextColor(9, 132, 227)
                doc.text(75, yaxis, date)
                      
                yaxis += 25
                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, yaxis, 'Address');

                yaxis += 10
                let address = `${customer.address1}, ${customer.address2}, ${customer.address3}, ${customer.address4}, ${customer.postCode}`
                doc.setFontSize(14);
                doc.setFont('helvetica', 'normal')
                doc.setTextColor(88, 88, 88)
                doc.text(20, yaxis, address)

                var contactCols = ['First Name', 'Surname', 'Job Title', 'Phone', 'Mobile', 'Email']
                var activeCols = ['Quote No','Description','Branch','Contact','Project', 'Value','Qty','Type']
                var lostCols = ['Quote No','Description','Branch','Contact','Project','Status Comment','Reason','Value','Qty','Type']
                var wonCols = ['Quote No','Description','Branch','Contact','Project','PO Number','Value','Qty','Type']
                var summaryStatsCols = ['', (new Date().getFullYear()-4).toString(), (new Date().getFullYear()-3).toString(), (new Date().getFullYear()-2).toString(), (new Date().getFullYear()-1).toString(), `${(new Date().getFullYear()).toString()} YTD` ]

                try 
                {
                  var contacts = await this.customerService.getActiveCustomerContacts(customer.customerId)
                  this.$store.dispatch('setPercentageUploaded', Math.round(20))

                  var contactRows = []
                  for(let i=0; i< contacts.length; i++)
                  {    
                    contactRows.push([contacts[i]['firstName'],contacts[i]['lastName'],contacts[i]['contactJobTitle'],contacts[i]['phoneNo'],contacts[i]['mobile'],contacts[i]['email']])
                  }
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching contacts",
                    life: 5000,
                  })
                }

                let reqObj = {
                  oppStatusName: 1, searchText: "*", customer: customer.customerId
                }

                if(this.onlyUserBranchCustomerInfoReport)
                {
                  reqObj['branchCode'] = branch.id
                }

                try 
                {
                  var activeQuotations = await this.opportunityService.getEnquiries(0,1,1000,0,0,'*',reqObj)
                  this.$store.dispatch('setPercentageUploaded', Math.round(30))
                  activeQuotations = activeQuotations.data
                  var activeRows = []
                  for(let i=0; i< activeQuotations.length; i++)
                  {    
                    activeRows.push([this.returnValue(activeQuotations[i],'sQuoteNo'),this.returnValue(activeQuotations[i],'oppDescription'),this.returnValue(activeQuotations[i],'mbpBranchCode'),this.returnValue(activeQuotations[i],'contactName'),this.returnValue(activeQuotations[i],'projTypeName'),this.tranformValue(this.returnValue(activeQuotations[i],'productValue')),this.returnValue(activeQuotations[i],'quoteQty'),this.returnValue(activeQuotations[i],'quoteProdTypeName')])
                  }
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching lost quotations",
                    life: 5000,
                  })
                }
                const dates = this.getDates()
                let reqObj1 = {
                  "dateStatusChangedFrom": dates[0],
                  "dateStatusChangedTo": dates[1],
                  customer: customer.customerId
                }

                if(this.onlyUserBranchCustomerInfoReport)
                {
                  reqObj1['branchCode'] = branch.id
                }

                try 
                {
                  var wonQuotations = await this.opportunityService.getQuotes("won", reqObj1)
                  wonQuotations = wonQuotations.data
                  this.$store.dispatch('setPercentageUploaded', Math.round(40))
                  var wonRows = []
                  for(let i=0; i< wonQuotations.length; i++)
                  {    
                    wonRows.push([this.returnValue(wonQuotations[i],'sQuoteNo'),this.returnValue(wonQuotations[i],'oppDescription'),this.returnValue(wonQuotations[i],'mbpBranchCode'),this.returnValue(wonQuotations[i],'contactName'),this.returnValue(wonQuotations[i],'projTypeName'),this.returnValue(wonQuotations[i],'statusComment'),this.tranformValue(this.returnValue(wonQuotations[i],'productValue')),this.returnValue(wonQuotations[i],'quoteQty'),this.returnValue(wonQuotations[i],'quoteProdTypeName')])
                  }
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching won quotations",
                    life: 5000,
                  })
                }
                
                try 
                {
                  var lostQuotations = await this.opportunityService.getQuotes("lost", reqObj1)
                  lostQuotations = lostQuotations.data
                  this.$store.dispatch('setPercentageUploaded', Math.round(50))

                  var lostRows = []
                  for(let i=0; i< lostQuotations.length; i++)
                  {    
                    lostRows.push([this.returnValue(lostQuotations[i],'sQuoteNo'),this.returnValue(lostQuotations[i],'oppDescription'),this.returnValue(lostQuotations[i],'mbpBranchCode'),this.returnValue(lostQuotations[i],'contactName'),this.returnValue(lostQuotations[i],'projTypeName'),this.returnValue(lostQuotations[i],'statusComment'),this.returnValue(lostQuotations[i],'lostQuoteReason'),this.tranformValue(this.returnValue(lostQuotations[i],'productValue')),this.returnValue(lostQuotations[i],'quoteQty'),this.returnValue(lostQuotations[i],'quoteProdTypeName')])
                  }
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching quotations",
                    life: 5000,
                  })
                }
                
                doc.addPage()
                var y = 25 

                doc.setTextColor(34, 166, 179)
                doc.setFontSize(18)
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Contacts')  

                y += 10
                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                  },
                  rowPageBreak: 'avoid',
                  didParseCell: function (HookData) {
                    maxCellY = HookData.cell.y;
                  },
                  bodyStyles: { valign: 'top' },
                  head: [contactCols],
                  body: contactRows,
                });

                y = doc.lastAutoTable.finalY;

                doc.addPage()
                y = 25 

                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Active Quotations')

                y += 10
                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                  },
                  didParseCell: function (HookData) {
                    maxCellY = HookData.cell.y;
                  },
                  rowPageBreak: 'avoid',
                  bodyStyles: { valign: 'top' },
                  head: [activeCols],
                  body: activeRows,
                });

                y = doc.lastAutoTable.finalY

                doc.addPage()
                y = 30 

                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Won Quotation');     

                y += 10
                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                  },
                  rowPageBreak: 'avoid',
                  didParseCell: function (HookData) {
                    maxCellY = HookData.cell.y;
                  },
                  bodyStyles: { valign: 'top' },
                  head: [wonCols],
                  body: wonRows,
                })
                
                y = doc.lastAutoTable.finalY

                doc.addPage()
                y = 30 

                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Lost Quotation');     

                y += 10
                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                  },
                  didParseCell: function (HookData) {
                    maxCellY = HookData.cell.y;
                  },
                  rowPageBreak: 'avoid',
                  bodyStyles: { valign: 'top' },
                  head: [lostCols],
                  body: lostRows,
                });

                y = doc.lastAutoTable.finalY;

                try 
                {
                  var json = await this.customerService.getCustomerStats(customer.customerId)
                  this.$store.dispatch('setPercentageUploaded', 100)
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching salesStats",
                    life: 5000,
                  })
                }

                // variables for SalesStat Table

                var sales = []
                var prevYearTotalForecast = 0
                var currYearTotalForecast = 0
                var prevYearTotalSales = 0
                var currYearTotalSales = 0
                var minus2YearTotalSales = 0
                var minus3YearTotalSales = 0
                var totalPerCChange = 0
                var totalPerCChangeForecast = 0
                var totalPerChangeMinus2Year = 0
                var totalPerChangeMinus3Year = 0
                var totalWons = 0
                var totalLosts = 0
                var totalCreated = 0

                let uptoMonths = 12
                let prevYear = null
                let currYear = null
                let minus2Year = null
                let minus3Year = null
                let row = {
                    branch: {},
                    prevYearForecast: 0,
                    currYearForecast: 0,
                    minus2YearSales: 0,
                    minus3YearSales: 0,
                    prevYearSales: 0,
                    currYearSales: 0,
                    percChangePrev : 0,
                    percChangeForecast: 0,
                    percChangeMinus2: 0,
                    percChangeMinus3: 0,
                    wonQuotes : 0,
                    lostQuotes : 0,
                    createdQuotes: 0,
                    months: []
                  }

                for (let i in json) {
                  if (json[i].rowMonth <= uptoMonths) {
                    
                    if (
                        (
                            prevYear && json[i].prevYear && json[i].prevYear < prevYear
                        ) ||
                        !prevYear
                    ) {
                        prevYear = json[i].prevYear
                    }
                    
                    if (
                        (
                            currYear && json[i].currYear && json[i].currYear > currYear
                        ) ||
                        !currYear
                    ) {
                        currYear = json[i].currYear
                    }

                      if (
                        (
                            minus2Year && json[i].minus2Year && json[i].minus2Year < minus2Year
                        ) ||
                        !minus2Year
                    ) {
                        minus2Year = json[i].minus2Year
                    }

                      if (
                        (
                            minus3Year && json[i].minus3Year && json[i].minus3Year < minus3Year
                        ) ||
                        !minus3Year
                    ) {
                        minus3Year = json[i].minus3Year
                    }

                    row.prevYearForecast += json[i].prevYearForecast
                    row.prevYearSales += json[i].prevYearSales
                    row.minus2YearSales += json[i].minus2YearSales
                    row.minus3YearSales  += json[i].minus3YearSales
                    row.currYearForecast += json[i].currYearForecast
                    row.currYearSales += json[i].currYearSales
                    row.percChangePrev += json[i].percChangePrev
                    row.percChangeMinus2 += json[i].percChangeMinus2
                    row.percChangeMinus3 += json[i].percChangeMinus3
                    row.percChangeForecast += json[i].percChangeForecast
                    row.wonQuotes += json[i].wonQuotes
                    row.lostQuotes += json[i].lostQuotes
                    row.createdQuotes += json[i].createdQuotes
                    row.months.push(json[i]) 
                    
                    prevYearTotalForecast += json[i].prevYearForecast
                    currYearTotalForecast += json[i].currYearForecast
                    minus2YearTotalSales += json[i].minus2YearSales
                    minus3YearTotalSales += json[i].minus3YearSales
                    prevYearTotalSales += json[i].prevYearSales
                    currYearTotalSales += json[i].currYearSales
                    totalPerCChange += json[i].percChangePrev
                    totalPerChangeMinus2Year += json[i].percChangeMinus2
                    totalPerChangeMinus3Year += json[i].percChangeMinus3
                    totalPerCChangeForecast += json[i].percChangeForecast
                    totalWons += json[i].wonQuotes
                    totalLosts += json[i].lostQuotes
                    totalCreated += json[i].createdQuotes

                    if (json[i].rowMonth == 1) {
                      
                        row.branch = {
                            branchId: json[i].branchId,
                            branchName: json[i].branchName,
                            branchCode: json[i].branchCode,
                            tasCode: json[i].tasCode,
                        }
                    }
                    if (json[i].rowMonth == uptoMonths) {
                        sales.push(row)

                        row = {
                          branch: {},
                          prevYearForecast: 0,
                          currYearForecast: 0,
                          minus2YearSales: 0,
                          minus3YearSales: 0,
                          prevYearSales: 0,
                          currYearSales: 0,
                          percChangePrev : 0,
                          percChangeForecast: 0,
                          percChangeMinus2: 0,
                          percChangeMinus3: 0,
                          wonQuotes : 0,
                          lostQuotes : 0,
                          createdQuotes: 0,
                          months: []
                        }
                    }
                  }
                }

                var salesRows = []
                for(let i=0; i<sales.length; i++) {

                  var salesPerc = 0
                  if(sales[i].prevYearSales != 0)
                  {
                    salesPerc = Math.round((sales[i].currYearSales - sales[i].prevYearSales) / sales[i].prevYearSales * 100)
                  }

                  var salesForc = 0
                  if(sales[i].currYearForecast != 0)
                  {
                    salesForc = Math.round((sales[i].currYearSales - sales[i].currYearForecast) / sales[i].currYearForecast * 100)
                  }

                  salesRows.push([
                    sales[i].branch.branchCode+' ('+sales[i].branch.tasCode+')',
                    this.tranformValue(sales[i].currYearForecast),
                    this.tranformValue(sales[i].prevYearSales),
                    this.tranformValue(sales[i].currYearSales),
                    salesPerc+'%',
                    salesForc+'%',
                    this.tranformValue(sales[i].wonQuotes),
                    this.tranformValue(sales[i].lostQuotes),
                    this.tranformValue(sales[i].createdQuotes)
                  ])
                }

                doc.addPage()
                y = 30 

                doc.setTextColor(34, 166, 179)
                doc.setFontSize(18)
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Sales Stats') 

                doc.setTextColor(0, 0, 0)
                y = y + 5

                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                    "halign": 'center',
                  },
                  headStyles: {
                    // fillColor: [248, 249, 250],
                    halign: 'center',
                    // textColor: '#000000',
                    // fontStyle: 'bold'
                  },
                  // didParseCell: function (data) {
                  //   maxCellY = data.cell.y;
                  //   if (data.row && data.row.raw && !data.row.raw[0].toString().includes('Month') && !data.row.raw[0].content && data.row.raw[0] != '2022') {
                  //       data.cell.styles.fillColor = [9, 132, 227]
                  //       data.cell.styles.fontStyle = 'bold'
                  //       data.cell.styles.textColor = 240
                  //   }
                  // },
                  rowPageBreak: 'avoid',
                  bodyStyles: { valign: 'top' },
                  head: [
                    [
                      {
                        content: 'Branch Code (TAS Code)',
                        rowSpan: 2,
                        columnWidth: 50
                      },
                      {
                        content: 'Forecast'
                      },
                      {
                        content: 'Sales',
                        colSpan: 2
                      },
                      {
                        content: 'Comparisons',
                        colSpan: 2
                      },
                      {
                        content: `${(new Date().getFullYear()).toString()} YTD Quotations`,
                        colSpan: 3
                      },
                    ],
                    [ `${(new Date().getFullYear()).toString()}`,(new Date().getFullYear()-1).toString(),`${(new Date().getFullYear()).toString()} YTD`,'Sales vs Prev Year %','Sales vs Forecast %','Won quotes','Lost quotes','Created Quotes'
                    ]
                  ],
                  body: salesRows,
                });


                try 
                {
                  var summaryStatsResponse = await this.customerService.getCustomerSummaryStats(customer.customerId)
                  this.$store.dispatch('setPercentageUploaded', Math.round(100))
                }
                catch(e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error fetching summary of salesStats",
                    life: 5000,
                  })
                }

                var summaryStatRows = []
                if(summaryStatsResponse && summaryStatsResponse.length > 0) {
                  for (const branch of summaryStatsResponse) {
                    var currentRow = []
                    if(branch?.branchCode)
                      currentRow.push(branch.branchCode)
                    else
                      currentRow.push("-")

                    if (branch?.minus4YearSales)
                      currentRow.push(this.tranformValue(branch.minus4YearSales))
                    else 
                      currentRow.push("-")

                    if (branch?.minus3YearSales)
                      currentRow.push(this.tranformValue(branch.minus3YearSales))
                    else 
                      currentRow.push("-")

                    if (branch?.minus2YearSales)
                      currentRow.push(this.tranformValue(branch.minus2YearSales))
                    else 
                      currentRow.push("-")

                    if (branch?.minus1YearSales)
                      currentRow.push(this.tranformValue(branch.minus1YearSales))
                    else 
                      currentRow.push("-")

                    if (branch?.currYearSales)
                      currentRow.push(this.tranformValue(branch.currYearSales))
                    else 
                      currentRow.push("-")
                  
                    summaryStatRows.push(currentRow)
                  }
                }

                doc.addPage()
                y = 30 

                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Summary of Sales section')  

                y += 10
                var maxCellY = y;
                doc.autoTable({
                  startY: y,
                  margin: {
                    top: 45,
                    bottom: 20,
                    left: 20,
                    right: 20,
                  },
                  styles: {
                    "font": "helvetica",
                    "fontStyle": "normal",
                  },
                  rowPageBreak: 'avoid',
                  didParseCell: function (HookData) {
                    maxCellY = HookData.cell.y;
                  },
                  bodyStyles: { valign: 'top' },
                  head: [summaryStatsCols],
                  body: summaryStatRows,
                })

                var canvas = this.$refs.myChart.$refs.canvas
                var image = canvas.toDataURL();
                var chartWidth = canvas.clientWidth;
                var chartHeight = canvas.clientHeight;
                var aspectRatio = chartWidth / chartHeight;

                var height = pageWidth / aspectRatio;

                doc.addPage()
                y = 30 

                doc.setTextColor(34, 166, 179);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'normal')
                doc.text(20, y, 'Sales Analysis')

                y += 10
                
                doc.addImage(image, "PNG", 20, y, pageWidth-20, height)
                
                doc.save('MBP_Customer_report.pdf')
                this.chartHide = false
                this.$store.dispatch('setUploading', false)
                this.$store.dispatch('setProgressMsg', 'File uploaded: ')
                this.$toast.add({
                    severity: "success",
                    summary: "Downloaded",
                    detail: "Report is donwloaded successfully!",
                    life: 5000,
                  })
              }
              catch(e) {
                this.$store.dispatch('setUploading', false)
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error exporting report",
                  life: 5000,
                })
              }
            }
          })
          .catch(e => {
            this.$store.dispatch('setUploading', false)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error exporting report",
              life: 5000,
            })
          })
      }
      catch(e) {
        this.$store.dispatch('setUploading', false)
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error fetching Chart Data",
          life: 5000,
        })
      }
      
    },
    adjustDocY(doc, y, height) {
      var pageHeight = doc.internal.pageSize.getHeight()
      if (y + height + 20 > pageHeight) {
        doc.addPage()
        y = 30
      }
      return y
    },
    returnValue(obj, key) {
      if(obj[key])
      return obj[key]
      else 
      return ''
    },
    tranformValue(val) {
      const formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(val);
    },
    noteSaved() {
      this.noteDialog = false;
      this.note = {};
    },
    newNote(customer) {
      if (customer && customer.customerId) {
        this.tempCustomer = customer
        // C27: fill the customer from the row and lock only that box (as the Enquiries list
        // does); disabledArr may still hold a previous action's locks
        this.note = {
          customer: {
            customerId: customer.customerId,
            custName: customer.custName
          }
        };
        this.disabledArr = ['Customer']
        this.noteDialog = true;
        this.reloadNoteForm++
      }
    },
    saved({ quote, file, params, active }) {
      
      this.activeQuote = false
      this.quotationDialog = false
      this.quotation = {};
    },
    newQuote() {
      // 
      
      this.disabledArr = [
        'opportunity',
        'mbpBranch',
        'Customer'
      ]
      // this.quotation = { ...this.opportunity, opportunity: this.opportunity };
      this.activeQuote = true
      this.quotationDialog = true;
    },
    savedOpportunity(e) {
      
      this.realOpportunity = e.opportunity
      this.selectedCustomer = e.customer
      if (e.duplicates && e.duplicates.length) {
        this.duplicates = e.duplicates;
        this.displayDuplicateMessage = true
      } else {
        if (e.sQuoteNo) {
          this.savedSQuoteNo = e.sQuoteNo.sQuoteNo
          this.displaySuccess = true
        }
      }
    },
    sendDuplicate() {
      this.duplicateRequesting = true
      
      
      this.realOpportunity.custCode = this.selectedCustomer.custCode

      this.opportunityService
        .saveDuplicateOpportunity(this.realOpportunity)
        .then((response) => {
          this.duplicateRequesting = false
          this.displayDuplicateMessage = false
          
          
          this.realOpportunity = response.data;
          
          
          this.savedSQuoteNo = this.realOpportunity.sQuoteNo
          this.displaySuccess = true
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Enquiry Saved",
              detail: `new Enquiry was saved successfully, Quote No generated : ${this.realOpportunity.sQuoteNo}`,
              life: 5000,
            });
            this.opportunityDialog = false;
          }
        })
        .catch((e) => {
          this.duplicateRequesting = false
          this.displayDuplicateMessage = false
          

          if (e.response)                
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000,
            })
        })
    },
    getColumnSelectionEnquiry() {
      this.filtersService
        .getColumnSelection(this.dbViewEnquiry)
        .then(data => {
          this.colSelectedFieldsEnquiry = data
          this.setupColumns()
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getDBViewFieldsEnquiry() {
      this.filtersService
        .getDBViewFields(this.dbViewEnquiry)
        .then(data => this.dbViewFieldsEnquiry = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    setupColumns() {

      let a = []
      this.colSelectedFieldsEnquiry.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTableEnquiry = a
      }
    },
    newEnquiry(customer) {
      if (customer && customer.customerId) {
        this.tempCustomer = customer

        this.opportunityToEdit.customer = customer
        this.opportunityToEdit.country = 'UK'
        this.disabledArr = [
          'Customer'
        ]
        this.openOpportunityDialog = true
      }
    },
    newActivity(customer) {
      if (customer && customer.customerId) {
        this.tempCustomer = customer

        this.activity = {
          user: this.$store.getters['auth/getMyProfile'],
          dateCreated: new Date()
        }
        this.disabledArr = [
          'customer'
        ]
        this.activity.customer = customer
        this.activity.mbpBranch = customer.mbpBranch
        this.activityDialog = true
      }
    },
    saveDuplicate() {
      this.duplicateDialog = false

      this.duplicateToSend.customer = this.tempCustomer.customerId

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000,
            });
          }
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving customer",
            life: 5000,
          })
        })
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      
      this.contactToEdit = {}
      this.contactDialog = false
      if (duplicateToSend) {
        this.duplicateToSend = duplicateToSend
        this.duplicateContact = duplicateContact
        this.duplicateDialog = true
      }
    },
    newContact(customer) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewContact');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new contact",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
            if (customer && customer.customerId) {
              this.tempCustomer = customer

              this.contactToEdit = {};
              this.contactToEdit.customerId = customer.customerId;
              this.contactToEdit.address1 = customer.address1;
              this.contactToEdit.address2 = customer.address2;
              this.contactToEdit.address3 = customer.address3;
              this.contactToEdit.address4 = customer.address4;
              this.contactToEdit.postCode = customer.postCode;
              this.contactToEdit.country = customer.country;
              this.contactToEdit.canEmail = true;
              this.contactToEdit.canCall = true;
              this.contactToEdit.canMail = true;
              this.contactToEdit.active = true;
              this.contactToEdit.keyContact = false;
              this.disabledArr = [
                'Customer'
              ]
              this.contactDialog = true;
            }
        }
      }
    },
    goTo(data) {
      if (data) {
        
        this.note = {}
        this.enquiry = {}


        if (data.linkTo === "ACTIVITY") {
          this.activityService
            .getActivity(data.linkId)
            .then(data => {
              this.activity = data
              this.disabledArr = [
                'buttons',
                'reminderDate',
                'reminderTime',
                'reminder',
                'reminderType',
                'duration',
                'endDate',
                'endTime',
                'startDate',
                'startTime',
                'notes',
                'quotation',
                'customer',
                'contact',
                'activityType',
                'mbpBranch',
                'user',
                'dateCreated',
                'subject',
              ]
              this.unRequestedActivity = false
              this.activityDialog = true
              this.activityFormKey++

            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "activity/{id}"'
              })
            });

        } else if (data.linkTo === "NOTE") {
          this.customerService
            .getNote(data.linkId)
            .then(data => {
              this.note = data
              this.disabledArr = [
                'noteHeader',
                'noteTags',
                'Customer',
                'Contact',
                'enquiry',
                'user',
                'noteDetails',
                'buttons',
              ]
              this.unRequestedNote = false
              this.noteDialog = true
              this.reloadNoteForm
              
            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "customernote/{id}"'
              })
            });
          
        } else if (data.linkTo === "ENQUIRY") {
          this.opportunityService
            .getOpportunity(data.linkId)
            .then(data => {
              this.enquiry = data
              this.disabledArr = [
                'Description',
                'Address 1',
                'Address 2',
                'Address 3',
                'City/Town',
                'Post Code',
                'Customer',
                'Contact',
                'Project Type',
                'mbpBranch',
                'Phone No',
                'Email',
                'Sales Exec',
                'Requested By',
                'ABI No',
                'Customer Ref',
                'Notes',
                'Buttons'
              ]
              this.unRequestedEnquiry = false
              this.enquiryDialog = true
              this.enquiryFormKey = this.enquiryFormKey1 + 1
              
            })
            .catch((e) => {
              
                
              this.$store.dispatch('addErrorMessage', {
                severity: 'error',
                content: 'Some data was not loaded from "opportunity/{id}"'
              })
            });

        }
      }
    },
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      
      if (
        event 
        && event.originalEvent 
        && event.originalEvent.target 
        && (
          event.originalEvent.target.classList.contains("under_lined")
          ||
          event.originalEvent.target.classList.contains("ignore")
        )
      ) {
        return
      } else {
        this.viewCustomer(event.data)
      }
    },
    setSplitButtonLocations() {
      // getElementsByClassName gives an HTMLCollection, which has no forEach (it threw on every list load).
      let a = Array.from(document.getElementsByClassName('splitButtonColumn'))
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    setupComponent() {
      
      
      if (this.$store.getters['customers/getSortField']) {
        this.defaultSortField = this.$store.getters['customers/getSortField']
        this.defaultSortOrder = this.$store.getters['customers/getSortOrder']
        this.defaultSortFieldId = this.$store.getters['customers/getSortFieldId']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
        this.defaultSortFieldId = null
      }

      this.defaultRows = this.$store.getters['customers/getRows']
      this.defaultFirstPage = (this.$store.getters['customers/getPage'] - 1) * this.defaultRows

    },
    onSort(event) {
      // C2: one sort, for the column clicked (by its own key, then its id), not every column sharing the last db_field segment
      const change = sortChangeFor(event, this.colSelectedFieldsForTable)
      if (change) this.$emit('sortChange', change)
    },
    sortKeyOf(col, cols) {
      return columnSortKey(col, cols)
    },
    onPage(event) {
      // 
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    editCustomer(customer) {
      this.$emit("editCustomer", customer);
    },
    viewCustomer(selcust) {
      this.$router.push({
        path: "customers/" + selcust.customerId + "/detail",
        params: { custid: selcust.customerId },
      });
    },
    viewCustomerContacts(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/contacts",
        params: { custid: data.customerId },
      });
    },
    viewCustomerActivities(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/activities",
        params: { custid: data.customerId },
      });
    },
    viewCustomerQuotations(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/quotations",
        params: { custid: data.customerId },
      });
    },
    viewCustomerNotes(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/notes",
        params: { custid: data.customerId },
      });
    },
    viewCustomerAttachments(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/attachments",
        params: { custid: data.customerId },
      });
    },
    setCustomerToInactive(data) {
      if (this.actionButtons3[5]) {
        this.actionButtons3[5].disabled = true
      }
      
      this.customerService
        .setCustomerToInactive(data.customerId)
        .then(data => {
          if (data === "OPEN ENQUIRIES EXIST") {
            this.$toast.add({
              severity: "warn",
              summary: "Failed",
              detail: "Customer can't be set to Inactive as Open Enquiries exist!",
              life: 5000,
            })

          } else if (data === "DONE") {
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Customer has been set to Inactive (Status: Closed)",
              life: 5000,
            })

            this.$emit('reload')
          }

        })
        .catch(error => {
          if (this.actionButtons3[5]) {
            this.actionButtons3[5].disabled = false
          }

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while setting customer to Inactive",
            life: 5000,
          })
        })
    },
    setCustomerToActive(data) {
      if (this.actionButtons3[5]) {
        this.actionButtons3[5].disabled = true
      }
      
      this.customerService
        .setCustomerToActive(data.customerId)
        .then(data => {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Customer has been set to Active",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          if (this.actionButtons3[5]) {
            this.actionButtons3[5].disabled = false
          }

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while setting customer to Inactive",
            life: 5000,
          })
        })
    },
    viewCustomerSalesStats(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/sales",
        params: { custid: data.customerId },
      });
    },
    viewCustomerHistory(data) {
      this.$router.push({
        path: "/customers/" + data.customerId + "/history",
        params: { custid: data.customerId },
      });
    },
    viewCustomerLinkedAccounts(data) {
      if (data && data.customerId) {
        this.linkedAccountsTableDialog = true
        this.reloadLinkedAccountsTableDialog++
      }
    },
    mergeCustomer() {
      if (this.selectedRow && this.selectedRow.customerId) {
        this.mergeDialog = true
        this.reloadMergeDialog++
      }
    },
    deleteCustomer() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteCustomer');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to delete a customer",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
          if (this.tempObj && this.tempObj.customerId) {
            this.deleteConfirmation = false
            this.customerService
              .deleteCustomer(this.tempObj.customerId)
              .then(data => this.$emit('reload'))
              .catch(error => {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while deleting customer ${this.tempObj.custName}.`,
                  life: 5000,
                })
              })
      }
        }
      }

    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data

      if(this.toggleActionFirst)
      this.entryIndex = this.actionButtons3.length

      this.actionButtons1[1].disabled = false
      for(let j=0; j<this.actionButtons3.length; j++)
      this.actionButtons3[j].disabled = false

      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'Action-SetCustActiveNotActive');
      if (permission) {
        if (permission.permissionLevel !== 0) {
          if (data.active) {
            for(let j=0; j<this.actionButtons3.length; j++)
            this.actionButtons3[j].disabled = false

            this.actionButtons3[this.entryIndex] = {
              label: 'Set Customer to Inactive',
              command: (that) => {
                that.setCustomerToInactive(that.selectedRow)
              }
            }
          } else {

            for(let j=0; j<this.actionButtons3.length; j++)
            this.actionButtons3[j].disabled = true

            this.actionButtons3[this.entryIndex] = {
              label: 'Set Customer to Active',
              command: (that) => {
                that.setCustomerToActive(that.selectedRow)
              }
            }
          }
        } else {
          if (!data.active) {
            this.actionButtons1[1].disabled = true
            for(let j=0; j<this.actionButtons3.length; j++)
            this.actionButtons3[j].disabled = true
          }
        }
        this.toggleActionFirst = false
      }



      this.$refs.opActions.toggle(event);
      // UI1c: the top row's menu flipped up under the fixed top bar (View / Edit / Delete hidden)
      this.$nextTick(() => {
        const panel = this.$refs.opActions && this.$refs.opActions.$refs.container
        keepOverlayOnScreen(panel, window.innerHeight, topbarBottom())
      })
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.editCustomer(data)
					}
				},
				{
					label: 'View Contacts',
					icon: 'pi pi-id-card',
					command: () => {
						this.viewCustomerContacts(data)
					}
        },
				{
					label: 'View Tasks & Events',
					icon: 'pi pi-calendar',
					command: () => {
						this.viewCustomerActivities(data)
					}
        },
				{
					label: 'View Quotations',
					icon: 'pi pi-money-bill',
					command: () => {
						this.viewCustomerQuotations(data)
					}
        },
				{
					label: 'View Notes',
					icon: 'pi pi-align-justify',
					command: () => {
						this.viewCustomerNotes(data)
					}
        },
				{
					label: 'View Attachments',
					icon: 'pi pi-file',
					command: () => {
						this.viewCustomerAttachments(data)
					}
        },
				{
					label: 'View Sales Stats',
					icon: 'pi pi-chart-line',
					command: () => {
						this.viewCustomerSalesStats(data)
					}
        },
				{
					label: 'View History',
					icon: 'pi pi-inbox',
					command: () => {
						this.viewCustomerHistory(data)
					}
        }
      ]
      buttons.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => {
          this.tempObj = data
          this.deleteConfirmation = true
        }
      })
      return buttons
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer1() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      
      
      if (col.dbField === 'custName' && data && data.customerId && event.target && event.target.className === "under_lined") {
        this.tempCustomer = data
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    getStyle2(col) {
      if (
        col.dbField === 'custName'
      ) {
        return 'under_lined'
      }
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                this.setSplitButtonLocations()

                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    setSelection({ value, index }) {
      // 
      this.customerForApproval = value
    }
  }
}
</script>

<style scoped>

</style>